export const getImageBlob = async (uri: string): Promise<Blob | null> => {
  try {
    const response = await fetch(uri);
    const blob = await response.blob();
    return blob;
  } catch (error) {
    return null;
  }
};
